type SectionHeaderProps = {
  num: string
  label: string
}

export function SectionHeader({ num, label }: SectionHeaderProps) {
  return (
    <div className="mb-5 flex items-center gap-3.5">
      <span className="border border-brand/65 px-2 py-1 font-mono font-semibold text-[10px] text-brand uppercase tracking-[0.22em]">
        {num}
      </span>
      <span className="font-mono text-[10px] text-white uppercase tracking-[0.4em]">
        {label}
      </span>
      <span aria-hidden="true" className="h-px flex-1 bg-white/15" />
    </div>
  )
}
